/**
 * Texture motion: the clock-driven scroll of the water normal maps and the bank foam (concept L1452, D3), plus the
 * floating-origin phase. The ground, water and foam UVs tile every 14, 26 and 34 m along z, which don't divide
 * 800 m, so each world shift would jump their patterns; the phase moves each texture back by exactly the shift
 * (master plan judgment call 16). Allocation-free: called every frame.
 */
import type { Texture } from 'three';
import { PERIOD } from '../core/math.ts';
import { GROUND_UV } from './terrain.ts';
import type { TextureSet } from './textures.ts';
import { FOAM_UV, N2_REPEAT, WATER_UV } from './water.ts';

/** Offset that cancels `shifts` world shifts for a texture repeating every `length` m along z (× its repeat). */
export function shiftPhase(shifts: number, length: number, repeat = 1): number {
  const v = (shifts * PERIOD * repeat) / length;
  return -(v - Math.floor(v));
}

export function poseTextures(
  TX: TextureSet,
  islandFoam: Texture | null,
  t: number,
  scroll: 'upriver' | 'downstream',
  shifts: number,
): void {
  const s = scroll === 'downstream' ? -1 : 1;
  TX.n1.offset.set(t * 0.006, s * t * 0.035 + shiftPhase(shifts, WATER_UV));
  TX.n2.offset.set(-t * 0.011, s * t * 0.052 + shiftPhase(shifts, WATER_UV, N2_REPEAT));
  TX.foam.offset.set(t * 0.05 + shiftPhase(shifts, FOAM_UV), 0);
  TX.ground.offset.set(0, shiftPhase(shifts, GROUND_UV));
  islandFoam?.offset.set(t * 0.05, 0);
}
